import React, { useContext, useEffect } from 'react'
import { UserContext } from 'bpm-sounds-generic'
import { Button } from 'bpm-sounds-generic'
import { GiveawayAPI } from '../../api/endpoints/giveaway'
import { GiveawayComment } from '../../api/models/giveaway'
import { USER_PLACEHOLDER } from 'bpm-sounds-generic/assets'

interface CommentBoxProps {
    contestId: string;
    editingComment?: GiveawayComment
    onCommentSubmit: (comment: GiveawayComment) => void;
}

const CommentBox = (props: CommentBoxProps) => {
    const user = useContext(UserContext)
    const [comment, setComment] = React.useState<string>(props.editingComment?.comment || '')

    useEffect(() => {
        if (props.editingComment) {
            setComment(props.editingComment.comment)
        }
    }, [props.editingComment])

    return (
        <div className="CommentBox">
            <div className="flex">
                {user.profile_image_thumbnail_url ? <img className="user-image" src={user.profile_image_thumbnail_url} /> : <img className="user-image" src={USER_PLACEHOLDER} />}
                <textarea name="" value={comment} onChange={(e) => setComment(e.target.value)}></textarea>
            </div>
            <Button
                buttonText={props.editingComment ? 'Edit Comment' : 'Post Comment'} textColor={'#fff'} backgroundColor={'var(--primary)'}
                hoverEffect={true}
                onClick={() => {
                    if (comment && comment.trim()) {
                        if (props.editingComment) {
                            GiveawayAPI.editComment(props.editingComment.id, comment).then((response) => {
                                setComment('')
                                props.onCommentSubmit(response)
                            }).catch((err) => {
                                console.log(err)
                            })
                        } else {
                            GiveawayAPI.commentGiveaway(props.contestId, comment).then((response) => {
                                setComment('')
                                props.onCommentSubmit(response)
                            }).catch((err) => {
                                console.log(err)
                            })
                        }
                    }
                }}
            />
        </div>
    )
}

export default CommentBox